import Question from "../Question/Question";
import styles from "./Break.module.css";
const Break = (props) => {
  return (
    <Question
      {...props}
      type="جدا کننده صفحه"
      noRequired
      cardType="inner"
      className={styles.Break}
    ></Question>
  );
};

export default Break;
